import { ModelCommon } from '../ModelCommon'

// Maps between Entity Type and Attribues of its scoring
const typeName = 'ScoreDefinitionMap'

type ScoreDefinition = {
  alertScores: string[]
  allowedAttributes: { key: string; label: string }[] // Key must match key in object history, label can be whatever
}

type ScoreDefinitionMapType = { [entityType: string]: ScoreDefinition }

class ScoreDefinitionMap extends ModelCommon {
  map: ScoreDefinitionMapType

  constructor(name: string, initMap: ScoreDefinitionMapType) {
    super(typeName, {})

    this.name = name ?? 'ScoreDefinitionMap'
    this.map = { ...initMap }
  }
}

export { ScoreDefinitionMap }
